import accountService from '@/services/accountService'
import { app as appService } from '@/services'
import humanizeDuration from 'humanize-duration'

const oneMinute = 60 * 1000
const oneHour = 60 * oneMinute
const oneDay = 24 * oneHour
let licenseInfoTime = 0
const licenseInfoCache = ref<any>(null)

const useLicense = () => {
  const trialExpired = (licenseInfo: any) => {
    licenseInfo ??= licenseInfoCache.value
    if (!!licenseInfo) {
      const now = +new Date()

      if (licenseInfo.exp && now > +(new Date(parseInt(licenseInfo.exp) * 1000))) {
        return true
      } else if (licenseInfo.hardexp && now > +(new Date(licenseInfo.hardexp)) + oneDay) {
        return true
      } else {
        return false
      }
    } else {
      return true // we will just say we are
    }
  }

  const isMarketplaceDeployment = computed<boolean>(() => {
    const licenseInfo = licenseInfoCache.value
    if (!!licenseInfo) {
      return !!licenseInfo.deployment_id
    } else {
      return false // we will just say we are not
    }
  })

  const refreshLicense = async (instance: string|null = null) => {
    if (!!licenseInfoTime) {
      const now = +new Date()

      // Don't refresh if we just did it.
      if (now - licenseInfoTime < 5 * oneMinute) {
        return
      }
    }

    // How to handle installing license in ui data model?
    const setLicenseInfo = (licenseInfo: any, usageMeteringStatus: any|null) => {
      licenseInfoTime = +new Date()
      licenseInfoCache.value = licenseInfo
      if (!licenseInfo) {

        // Offline?  Just no-op.
        if (appService.notices?.communicationErrors?.global) {
          appService.notices.license.warning = ''
        } else {
          appService.notices.license.warning = 'This software is unlicensed'
        }
      } else {
        appService.notices.license.warning = ''
        appService.notices.license.error = ''

        // Check expirations.
        appService.notices.license.exp = licenseInfo.exp
        appService.notices.license.softexp = licenseInfo.softexp
        appService.notices.license.hardexp = licenseInfo.hardexp
        appService.notices.license.trial = licenseInfo.trial
        appService.notices.license.deployment_id = licenseInfo.trial

        // If the license is expired....
        const now = +new Date()
        let exp, expired
        if (licenseInfo.exp && now > +(exp = new Date(parseInt(licenseInfo.exp) * 1000))) {
          appService.notices.license.warning = `The license installed for Yellowbrick has expired`
          expired = true
        } else if (licenseInfo.hardexp && now > +(exp = new Date(licenseInfo.hardexp)) + oneDay) {
          appService.notices.license.warning = `The license installed for Yellowbrick has expired`
          expired = true
        } else if (licenseInfo.softexp && now > +(exp = new Date(licenseInfo.softexp)) + oneDay) {
          appService.notices.license.warning = 'The license installed for Yellowbrick will expire soon'
          if (licenseInfo.hardexp) {
            exp = +(new Date(licenseInfo.hardexp)) + oneDay
            appService.notices.license.warning += ` (in ${humanizeDuration(exp - now, { units: ['d', 'h'], maxDecimalPoints: 0 })})`
          }
        }

        // If the license is for a deployment, we need additional information about the deployment connectivity to show.
        if ((!expired || !licenseInfo.trial) && licenseInfo.deployment_id) {
          const exp = +(new Date(licenseInfo.exp || licenseInfo.hardexp))
          const meteringLastSend = +(new Date(usageMeteringStatus?.meteringLastSend || 0))
          const licenseDuration = 7 * oneDay
          if (exp - now <= (licenseDuration - oneDay) && now - meteringLastSend > oneDay) {
            appService.notices.license.error = 'The Yellowbrick license cannot be renewed'
          }
        }
      }
      false && console.log('Updated license info', appService.notices.license)
    }

    // Get license info and optionally usage metering status.
    let _licenseInfo, _usageMeteringStatus
    if (instance) {
      _licenseInfo = accountService.getInstanceLicenseInfo(instance)
    } else {
      _licenseInfo = await accountService.getAnyLicenseInfo()
    }
    if (_licenseInfo?.deployment_id) {
      _usageMeteringStatus = await accountService.getMeteringStatus()
    }

    // Process the license+usage metering status.
    setLicenseInfo(_licenseInfo, _usageMeteringStatus)
  }

  const clearCache = () => {
    licenseInfoCache.value = null
    licenseInfoTime = 0
  }

  return { trialExpired, isMarketplaceDeployment, refreshLicense, clearCache }
}
export default useLicense
